$(document).ready(function(){
	
	// Setup selector for product info and recipes
    $('.selector').click(function(e){
		
		// Remove .selected from active <li> and add it to the clicked <li>
		$('.selector').removeClass('active');
		$(this).addClass('active');
		
		// Show the clicked link's <div> and hide the other
		var clicked = e.target.id;
		if (clicked == "single-product-info-link") {
			$('#single-product-description').removeClass('hidden');
			$('#single-product-recipes').addClass('hidden');
		} else {
			$('#single-product-recipes').removeClass('hidden');
			$('#single-product-description').addClass('hidden');
		}
	});
	// end selector
	
 	
	// Setup bxslider for product images
	$('.bxslider').bxSlider({
			auto: false,
			responsive: true,
			controls: true,
			autoHover: true,
			slideWidth: 458,
			autoControls: true,
			adaptiveHeight: true
	});
	
	// Use Selectize to change dropdown select menu for product variants
	// $('.product-options select').selectize();
	// 	$('.single-option-selector').selectize();
	
});
